import { BlobServiceClient } from "@azure/storage-blob";
import AppConfigs from "./env";
import { getSasToken } from "api/common";

// Get file from server
export const getFileBlobFromServer = async (fileName) => {
  try {
    if (!fileName) return null;

    // call api get sastoken and endpoint to upload
    let res = await getSasToken();
    res = {
      ...res,
      data: {
        sasToken: res.data.data.token,
        blobEndpoint: res.data.data.storageEndpoint,
        cdnFormatEndpoint: res.data.data.cdnEndpoint,
        containerName :res.data.data.containerName
      },
    };

    if (
      res.status === 200 &&
      res?.data?.sasToken &&
      res?.data?.blobEndpoint &&
      res?.data?.cdnFormatEndpoint
    ) {
      const sasToken = res.data.sasToken;
      const urlEndPoint = new URL(res.data.blobEndpoint);
      const endPoint = urlEndPoint.origin;
      // const container = urlEndPoint.pathname?.replace("/", "");
      const container = res.data.containerName;
      const cdnEndPoint = res.data.cdnFormatEndpoint;

      // auth with sastoken
      const blobService = new BlobServiceClient(`${endPoint}/?${sasToken}`);

      // get Container - full public read access
      const containerClient = blobService.getContainerClient(container);
      const blobClient = containerClient.getBlobClient(fileName);
      const downloadBlockBlobResponse = await blobClient.download();
      const downloaded = await blobToString(
        await downloadBlockBlobResponse.blobBody
      );
      return downloaded;
    }
  } catch (err) {
    return null;
  }
};

// Upload logo, image, file to server
export const uploadFileToBlob = async (file) => {
  try {
    if (!file) return null;

    // call api get sastoken and endpoint to upload
    let res = await getSasToken();
    res = {
      ...res,
      data: {
        sasToken: res.data.data.token,
        blobEndpoint: res.data.data.storageEndpoint,
        cdnFormatEndpoint: res.data.data.cdnEndpoint,
        containerName :res.data.data.containerName

      },
    };
    if (
      res.status === 200 &&
      res?.data?.sasToken &&
      res?.data?.blobEndpoint &&
      res?.data?.cdnFormatEndpoint
    ) {
      const sasToken = res.data.sasToken;
      const urlEndPoint = new URL(res.data.blobEndpoint);
      const endPoint = urlEndPoint.origin;
      const container = res.data.containerName
      const cdnEndPoint = res.data.cdnFormatEndpoint;

      // auth with sastoken
      const blobService = new BlobServiceClient(`${endPoint}/?${sasToken}`);

      // get Container - full public read access
      const containerClient = blobService.getContainerClient(container);

      const timenow = new Date().getTime();

      // upload file
      await createBlobInContainer(containerClient, file, timenow);

      let fileName = file.name;
      fileName = fileName.replaceAll(" ", "_");

      // return url file uploaded
      const returnedBlobUrls = `${cdnEndPoint}/${container}/${timenow}_${fileName}`;
      console.log("returnedBlobUrls", returnedBlobUrls);
      return returnedBlobUrls;
    } else {
      return null;
    }
  } catch (e) {
    console.log(e);
  }
};

// Upload file excel segment to server
export const uploadSegmentToBlob = async (file) => {
  try {
    if (!file) return null;

    // call api get sastoken and endpoint to upload
    let res = await getSasToken();
    res = {
      ...res,
      data: {
        sasToken: res.data.data.token,
        blobEndpoint: res.data.data.storageEndpoint,
        cdnFormatEndpoint: res.data.data.cdnEndpoint,
      },
    };
    if (
      res.status === 200 &&
      res?.data?.sasToken &&
      res?.data?.blobEndpoint &&
      res?.data?.cdnFormatEndpoint
    ) {
      const sasToken = res.data.sasToken;

      const urlEndPoint = new URL(res.data.blobEndpoint);
      const endPoint = urlEndPoint.origin;
      const container = urlEndPoint.pathname?.replace("/", "");

      // auth with sastoken
      const blobService = new BlobServiceClient(`${endPoint}/?${sasToken}`);

      // get Container - full public read access
      const containerClient = blobService.getContainerClient(container);

      const timenow = new Date().getTime();

      // upload file
      await createBlobInContainer(containerClient, file, timenow);

      let fileName = file.name;

      if (
        file.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      ) {
        fileName = fileName.replaceAll(" ", "_").replace(".xlsx", "");
        fileName = `${fileName}_${timenow}.xlsx`;
      } else if (file.type === "application/vnd.ms-excel") {
        fileName = fileName.replaceAll(" ", "_").replace(".xls", "");
        fileName = `${fileName}_${timenow}.xls`;
      } else {
        fileName = fileName.replaceAll(" ", "_");
        fileName = `${fileName}_${timenow}`;
      }

      // return name file uploaded
      return fileName;
    } else {
      return null;
    }
  } catch (e) {
    console.log(e);
  }
};

// create blob in container to upload
const createBlobInContainer = async (containerClient, file, timenow) => {
  let fileName = file.name;

  if (
    file.type ===
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
  ) {
    fileName = fileName.replaceAll(" ", "_").replace(".xlsx", "");
    fileName = `${timenow}_${fileName}.xlsx`;
  } else if (file.type === "application/vnd.ms-excel") {
    fileName = fileName.replaceAll(" ", "_").replace(".xls", "");
    fileName = `${timenow}_${fileName}.xls`;
  } else {
    fileName = fileName.replaceAll(" ", "_");
    fileName = `${timenow}_${fileName}`;
  }

  // create blobClient for container
  const blobClient = containerClient.getBlockBlobClient(`${fileName}`);

  // set mimetype as determined from browser with file upload control
  const options = { blobHTTPHeaders: { blobContentType: file.type } };

  // upload file
  await blobClient.uploadBrowserData(file, options);
  return;
};

const blobToString = async (blob) => {
  const fileReader = new FileReader();
  return new Promise((resolve, reject) => {
    fileReader.onloadend = (ev) => {
      resolve(ev.target.result);
    };
    fileReader.onerror = reject;
    fileReader.readAsText(blob);
  });
};
